/* eslint-disable no-unused-expressions */
/* global G */

/**
 * Checks whether `value` can be parsed as a JSON.
 *
 * @param {Gaia.Model} obj                  the model to validate
 * @returns {function(*, *): Promise<*[]>}
 */
export default obj => async (uiState, key) => {
  const { options } = obj[G.CONFIGURATION].validator[key]
  const { error } = options
  const { value } = uiState

  if (!value) {
    throw TypeError(error)
  }

  try {
    JSON.parse(value)
  } catch (e) {
    throw TypeError(error)
  }

  return [uiState, key]
}
